import { schema } from "normalizr"

export const libraryCategorySchema = new schema.Entity("libraryCategories")
